/* istanbul ignore next */
export const DROPDOWN_LIMIT = "5";
